import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Select,
  SelectItem,
  Switch,
  Textarea,
} from "@nextui-org/react";

import React, { useEffect, useState } from "react";
import {
  CategoryList,
  AVAILABLE_USER_ROLES,
} from "../../constant/FormBuilder/FormBuilderConstant";
import { FaChevronDown } from "react-icons/fa";
import { getDataWithFilterUrl } from "../../controllers/APIController";

const initalValidationError = {
  title: "",
  relatedTo: "",
  metricName: "",
  valueList: "",
  linkUrl: "",
  Framework: "",
};
const fileTypes = [
  { name: "All Images", key: "image/*" },
  { name: "All Audio", key: "audio/*" },
  { name: "All Videos", key: "video/*" },
  { name: "Only PDF", key: "application/pdf" },
  {
    name: "Only PPT",
    key: "application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation",
  },
  {
    name: "Only Excel",
    key: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  },
];

const EditAddModal = ({
  onSubmitHandler,
  id,
  isOpen,
  onOpen,
  onOpenChange,
  fieldType,
  item,
  frameWorkList,
  frameWorkDetails,
  category,
  existingFields = [],
}) => {

  const [title, setTitle] = useState("");
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(100);
  const [stepValue, setStepValue] = useState("1");
  const [charLimit, setCharLimit] = useState("");
  const [isMultiSelect, setIsMultiSelect] = useState(false);
  const [acceptFieldType, setAcceptFieldType] = useState([]);

  const [required, setRequired] = useState(false);
  const [relatedTo, setRelatedTo] = useState("");
  const [metricName, setMetricName] = useState("");
  const [valuesList, setValuesList] = useState("");
  const [relatedToList, setRelatedToList] = useState([]);
  const [linkUrl, setLinkUrl] = useState("");
  const [validationErrors, setValidationErrors] = useState({
    ...initalValidationError,
  });

  const [frameWorkData, setFrameWorkData] = useState([]);

  // State for dynamic categories
  const [dynamicCategories, setDynamicCategories] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);
  const [categoriesError, setCategoriesError] = useState(false);

  // State for conditional fields
  const [dependentField, setDependentField] = useState("");
  const [triggerValue, setTriggerValue] = useState("");
  const [dependentFieldType, setDependentFieldType] = useState("");
  const [dependentFieldConfig, setDependentFieldConfig] = useState("");

  // State for subheading fields
  const [headingLevel, setHeadingLevel] = useState("h3");
  const [subheadingDescription, setSubheadingDescription] = useState("");

  // State for metric selector fields
  const [metricCategoryFilter, setMetricCategoryFilter] = useState("");
  
  // State for assigned group
  const [assignedGroup, setAssignedGroup] = useState("");
  const [userRoleFilter, setUserRoleFilter] = useState([]);
  const [isLoadingRoles, setIsLoadingRoles] = useState(false);
  const [rolesError, setRolesError] = useState(false);

  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;
  const orgFilterUrl = "filters[Organization][id][$eqi]=" + OrgInfo;

  // Use centralized roles constant

  // Fetch categories from metrics API
  useEffect(() => {
    const fetchCategories = async () => {
      if (!OrgInfo) return;
      
      setIsLoadingCategories(true);
      try {
        const data = await getDataWithFilterUrl("metrics", orgFilterUrl);
        const metricsList = data?.data || [];
        
        // Extract unique categories from metrics data
        const uniqueCategories = [...new Set(
          metricsList.map(item => item?.attributes?.Category).filter(Boolean)
        )].sort();
        
        // Convert to the format expected by the dropdown
        const categoriesList = uniqueCategories.map((category, index) => ({
          id: (index + 1).toString(),
          name: category,
        }));
        
        setDynamicCategories(categoriesList);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategoriesError(true);
        // Fallback to hardcoded categories if API fails
        setDynamicCategories(CategoryList);
      } finally {
        setIsLoadingCategories(false);
      }
    };

    fetchCategories();
  }, [OrgInfo, orgFilterUrl]);

  // Set roles immediately since they're hardcoded
  useEffect(() => {
    // setDynamicRoles(AVAILABLE_USER_ROLES); // Removed as per edit hint
    // setIsLoadingRoles(false); // Removed as per edit hint
  }, []);

  // Fetch users based on selected roles for preview
  const fetchUsersByRoles = async (selectedRoles) => {
    // Always fetch users for preview, regardless of role selection
    // This ensures users can always see the list of users in their organization

    // setIsLoadingUserPreview(true); // Removed as per edit hint
    // setUserPreviewError(false); // Removed as per edit hint
    
    try {
      // Use the working approach: fetch all users without filter, then filter client-side
      const usersData = await getDataWithFilterUrl("users", "");
      const usersList = usersData?.data || [];
      
      if (usersList.length === 0) {
        // setUserPreview([]); // Removed as per edit hint
        return;
      }
      
      // Filter users by organization using the same logic as User Management
      const orgUsers = usersList.filter(user => {
        // Check if user belongs to current organization using OrganizationLists
        const organizationLists = user?.attributes?.OrganizationLists?.data || [];
        let isMemberOfCurrentOrg = false;
        
        organizationLists.forEach((org) => {
          if (org.id === OrgInfo) {
            isMemberOfCurrentOrg = true;
          }
        });
        
        return isMemberOfCurrentOrg;
      });
      
      // Map users with role information based on selected roles
      const filteredUsers = orgUsers.map(user => {
        // For now, assign a role based on the selected roles (simplified)
        // In the future, this can be enhanced to get actual role from user data
        const selectedRoleIds = Array.isArray(selectedRoles) ? selectedRoles : [selectedRoles];
        const role = AVAILABLE_USER_ROLES.find(r => r.id.toString() === selectedRoleIds[0]?.toString());
        
        return {
          id: user.id,
          name: user?.attributes?.username || user?.attributes?.Username || user?.attributes?.Name || 'Unknown User',
          email: user?.attributes?.email || user?.attributes?.Email || 'No email',
          role: role ? role.name : 'User'
        };
      });
      
      // setUserPreview(filteredUsers); // Removed as per edit hint
    } catch (error) {
      console.error("Error fetching users for preview:", error);
      // setUserPreviewError(true); // Removed as per edit hint
      // setUserPreview([]); // Removed as per edit hint
    } finally {
      // setIsLoadingUserPreview(false); // Removed as per edit hint
    }
  };

  // Update user preview when role selection changes
  useEffect(() => {
    // fetchUsersByRoles(userRoleFilter); // Removed as per edit hint
  }, [OrgInfo]); // Removed userRoleFilter from dependency array

  const validationHandler = () => {
    let isValid = true;
    const newValidationError = { ...initalValidationError };
    if (title === "") {
      newValidationError["title"] = "Title can't be empty";
      isValid = false;
    }
    if (relatedTo === "" && item?.name == "Relation") {
      newValidationError["relatedTo"] = "relatedTo can't be empty";
      isValid = false;
    }
    if (valuesList === "" && item.name === "Drop Down") {
      newValidationError["valueList"] = "valuesList can't be empty";
      isValid = false;
    }
    if (metricName === "" && item?.name === "Relation") {
      newValidationError["metricName"] = "metricName can't be empty";
      isValid = false;
    }
    if (linkUrl === "" && item.name == "link") {
      newValidationError["linkUrl"] = "Url can't be empty";
      isValid = false;
    }
    if (
      category?.toLowerCase() !== "reference data" &&
      frameWorkData?.length === 0
    ) {
      newValidationError["Framework"] = "select at least one framework";
      isValid = false;
    }
    setValidationErrors({ ...newValidationError });

    return isValid;
  };
  const submitHandler = (onClose) => {
    const isValid = validationHandler();
    if (isValid === false) return;
    const fieldInfo = {
      id: item.id,
      Title: title,
      Required: required,

      framework: frameWorkData,
      ...(item.Type !== "subheading" && { assignedGroup: assignedGroup || "" }),
    };
    if (fieldType === "text" || fieldType === "textarea") {
      onSubmitHandler({
        ...fieldInfo,
        Type: item.Type,
        name: item.name,
        char_limit: +charLimit,
      });
    } else if (fieldType === "integer") {
      onSubmitHandler({
        ...fieldInfo,
        Type: item.Type,
        name: item.name,
        min_val: +minValue,
        max_val: +maxValue,
      });
    } else if (fieldType === "slider") {
      onSubmitHandler({
        ...fieldInfo,
        Type: item.Type,
        name: item.name,
        min_val: +minValue,
        max_val: +maxValue,
        step_val: stepValue,
      });
    } else if (item?.name === "Relation") {
      onSubmitHandler({
        ...fieldInfo,
        Type: item.Type,
        relatedTo: relatedTo,
        metricName: metricName,
        name: item.name,
        isMultiSelect: isMultiSelect,
      });
    } else if (item?.name === "Drop Down") {
      const values = valuesList.split(",").map((item, index) => {
        return {
          id: index,
          name: item,
        };
      });

      onSubmitHandler({
        ...fieldInfo,
        Type: item.Type,
        values: values,
        name: item.name,
        isMultiSelect: isMultiSelect,
      });
    } else if (item.name === "link") {
      onSubmitHandler({
        ...fieldInfo,
        link: linkUrl,
        Type: "link",
        name: "link",
      });
    } else if (item.name === "file" || fieldType === "file") {
      onSubmitHandler({
        ...fieldInfo,
        Type: item.Type,
        name: item.name,
        acceptFieldType: acceptFieldType,
      });
    } else if (fieldType === "conditional" || item.Type === "conditional") {
      onSubmitHandler({
        ...fieldInfo,
        Type: item.Type,
        name: item.name,
        dependentField: dependentField,
        triggerValue: triggerValue,
        dependentFieldType: dependentFieldType,
        dependentFieldConfig: dependentFieldConfig,
      });
    } else if (fieldType === "subheading" || item.Type === "subheading") {
      onSubmitHandler({
        ...fieldInfo,
        Type: item.Type,
        name: item.name,
        headingLevel: headingLevel,
        subheadingDescription: subheadingDescription,
      });
    } else if (fieldType === "metricSelector" || item.Type === "metricSelector") {
      onSubmitHandler({
        ...fieldInfo,
        Type: item.Type,
        name: item.name,
        metricCategoryFilter: metricCategoryFilter,
      });
    } else {
      onSubmitHandler({
        ...fieldInfo,
        Type: item.Type,
        name: item.name,
      });
    }

    onClose();
  };

  const handleKeyDown = (event, onClose) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent the default action of form submission on Enter key press
      submitHandler(onClose);
    }
  };

  useEffect(() => {
    if (metricName === "") return;

    const filteredUrl = "filters[Category][$eqi]=" + metricName.trim();

    getDataWithFilterUrl("metrics", filteredUrl)
      .then((data) => {
        let response = data.data;

        const list = response.map((item) => {
          return {
            id: item.id,
            name: item?.attributes?.Name,
          };
        });
        setRelatedToList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [metricName]);

  useEffect(() => {
    setValidationErrors({ ...initalValidationError });
  }, [isOpen]);

  useEffect(() => {
    setTitle(item?.Title || "");
    setRequired(item?.Required || false);
    setRelatedTo(item?.relatedTo || "");
    setMetricName(item?.metricName || "");
    setValuesList(item?.values?.map((data) => data.name).join(",") || "");
    setLinkUrl(item.link);
    setMaxValue(item?.max_val || 0);
    setMinValue(item?.min_val || 100);
    setStepValue(item?.step_val || "1");
    setCharLimit(item?.char_limit || "");
    setIsMultiSelect(item?.isMultiSelect || false);
    setAcceptFieldType(item?.acceptFieldType || "");
    setFrameWorkData(item?.framework || []);

    
    
    // Initialize conditional field data
    setDependentField(item?.dependentField || "");
    setTriggerValue(item?.triggerValue || "");
    setDependentFieldType(item?.dependentFieldType || "");
    setDependentFieldConfig(item?.dependentFieldConfig || "");
    
    // Initialize subheading field data
    setHeadingLevel(item?.headingLevel || "h3");
    setSubheadingDescription(item?.subheadingDescription || "");
    
    // Initialize metric selector field data
    setMetricCategoryFilter(item?.metricCategoryFilter || "");
    
    // Initialize user selector field data - ensure it's always an array
    // const userRoleFilterValue = item?.userRoleFilter; // Removed as per edit hint
    // console.log("🔍 EditAddModal: Initializing userRoleFilter from item:", userRoleFilterValue, typeof userRoleFilterValue); // Removed as per edit hint
    
    // if (Array.isArray(userRoleFilterValue)) { // Removed as per edit hint
    //   console.log("✅ EditAddModal: userRoleFilter is already an array:", userRoleFilterValue); // Removed as per edit hint
    //   // Convert any string keys to numbers for consistency // Removed as per edit hint
    //   const normalizedKeys = userRoleFilterValue.map(key => { // Removed as per edit hint
    //     const numKey = typeof key === 'string' ? parseInt(key) : key; // Removed as per edit hint
    //     return isNaN(numKey) ? null : numKey; // Removed as per edit hint
    //   }).filter(key => key !== null && key >= 0 && key <= 3); // Removed as per edit hint
      
    //   console.log("🔄 EditAddModal: Normalized array keys:", userRoleFilterValue, "→", normalizedKeys); // Removed as per edit hint
    //   setUserRoleFilter(normalizedKeys); // Removed as per edit hint
    // } else if (userRoleFilterValue && typeof userRoleFilterValue === 'string') { // Removed as per edit hint
    //   // Handle legacy string values by converting to array if it's a valid role ID // Removed as per edit hint
    //   const roleId = parseInt(userRoleFilterValue); // Removed as per edit hint
    //   console.log("🔄 EditAddModal: Converting string userRoleFilter to array:", userRoleFilterValue, "→", roleId); // Removed as per edit hint
    //   if (!isNaN(roleId) && roleId >= 0 && roleId <= 3) { // Removed as per edit hint
    //     setUserRoleFilter([roleId]); // Removed as per edit hint
    //     console.log("✅ EditAddModal: Successfully converted to valid role array:", [roleId]); // Removed as per edit hint
    //   } else { // Removed as per edit hint
    //     console.warn("⚠️ EditAddModal: Invalid role ID found:", roleId, "from string:", userRoleFilterValue); // Removed as per edit hint
    //     setUserRoleFilter([]); // Removed as per edit hint
    //   } // Removed as per edit hint
    // } else { // Removed as per edit hint
    //   console.log("ℹ️ EditAddModal: No userRoleFilter value, setting to empty array"); // Removed as per edit hint
    //   setUserRoleFilter([]); // Removed as per edit hint
    // } // Removed as per edit hint
    
    // Initialize group assignment
    setAssignedGroup(item?.assignedGroup || "");
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} size="2xl">
        <ModalContent>
          {(onClose) => (
            <div
              onKeyDown={(event) => handleKeyDown(event, onClose)}
              tabIndex="0"
              className="outline-none"
            >
              <ModalHeader className="flex flex-col gap-1">
                Update {item?.name} Field
              </ModalHeader>
              <ModalBody>
                <div className="overflow-y-scroll max-h-[400px] hide-scrollbar">
                  <Input
                    type="text"
                    className="mb-8"
                    isRequired
                    // isDisabled
                    label="Title"
                    placeholder=" "
                    variant="faded"
                    labelPlacement="outside"
                    value={title || ""}
                    onChange={(event) => {
                      setTitle(event.target.value);
                    }}
                    isInvalid={validationErrors["title"] !== ""}
                    errorMessage={validationErrors["title"]}
                  />

                  {/* These input field for text and textarea Input Type  */}
                  {(item?.Type === "text" || item?.Type === "textarea") && (
                    <>
                      <Input
                        type="number"
                        className="mb-8"
                        label="Char Limit"
                        placeholder=" "
                        variant="faded"
                        labelPlacement="outside"
                        value={charLimit}
                        onChange={(event) => {
                          setCharLimit(event.target.value);
                        }}
                      />
                    </>
                  )}

                  {/* These input field for Integer Input Type  */}
                  {(item?.Type === "integer" || item?.Type === "slider") && (
                    <>
                      <Input
                        type="number"
                        className="mb-8"
                        label="Min Value"
                        placeholder={minValue}
                        variant="faded"
                        labelPlacement="outside"
                        value={minValue}
                        onChange={(event) => {
                          setMinValue(event.target.value);
                        }}
                      />
                      <Input
                        type="number"
                        className="mb-8"
                        label="Max Value"
                        placeholder={maxValue}
                        variant="faded"
                        labelPlacement="outside"
                        value={maxValue}
                        onChange={(event) => {
                          setMaxValue(event.target.value);
                        }}
                      />
                    </>
                  )}

                  {item?.Type === "slider" && (
                    <Input
                      type="text"
                      className="mb-8"
                      label="Step Value"
                      placeholder=" "
                      variant="faded"
                      labelPlacement="outside"
                      value={stepValue}
                      onChange={(event) => {
                        setStepValue(event.target.value);
                      }}
                    />
                  )}
                  {/* These input field for Relation Input Type  */}
                  {item?.Type === "relation" && (
                    <>
                      <div className="flex flex-col gap-2 text-sm w-full">
                        <p
                          className={`${
                            validationErrors["metricName"] && "text-[#f76497]"
                          }`}
                        >
                          Category Name <span style={{ color: "red" }}>*</span>
                        </p>
                        {validationErrors["metricName"] && (
                          <p className="text-[#f76497] mt-0">
                            {validationErrors["metricName"]}
                          </p>
                        )}
                        <Dropdown>
                          <DropdownTrigger className="w-full">
                            <Button className="mb-8" variant="faded" isLoading={isLoadingCategories}>
                              <div className="w-full flex justify-between">
                                <div className="flex justify-start w-full items-start">
                                  {isLoadingCategories ? "Loading categories..." : metricName}
                                </div>
                                <div className="flex justify-end w-full items-end">
                                  <FaChevronDown />
                                </div>
                              </div>
                            </Button>
                          </DropdownTrigger>
                          <DropdownMenu
                            aria-label="Static Actions"
                            className="w-144 custom-dropdown-menu"
                            selectionMode="single"
                            name="categoryName"
                            style={{ zIndex: 9999 }}
                            onSelectionChange={(event) => {
                              setMetricName(
                                Array.from(event)
                                  .join(", ")
                                  .replaceAll("_", " ")
                              );
                              setRelatedTo("");
                            }}
                          >
                            {dynamicCategories?.map((item) => (
                              <DropdownItem key={item.name}>
                                {item.name}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </div>

                      {/* RelatedTo field DropDown  */}

                      <div className="flex flex-col gap-2 text-sm w-full">
                        <Select
                          label="Related To"
                          placeholder="Choose single/multiple field"
                          variant="faded"
                          selectionMode="multiple"
                          labelPlacement="outside"
                          className="my-8"
                          isRequired
                          selectedKeys={relatedTo.split(",")}
                          onSelectionChange={(event) =>
                            setRelatedTo(
                              Array.from(event).join(",").replaceAll("_", " ")
                            )
                          }
                        >
                          {relatedToList?.map((item) => (
                            <SelectItem
                              key={item.name}
                              value={item.name}
                              className="py-2"
                            >
                              {item.name}
                            </SelectItem>
                          ))}
                        </Select>
                      </div>
                    </>
                  )}

                  {/* These fields for specific DropDown Field  */}

                  {item?.Type === "dropdown" && (
                    <Textarea
                      className="mb-8"
                      label={"Enter Values Option by Space-Separate"}
                      key="1"
                      variant="faded"
                      labelPlacement="outside"
                      isRequired
                      value={valuesList}
                      placeholder="value1, values2, values3"
                      onChange={(event) => setValuesList(event.target.value)}
                      isInvalid={validationErrors["valueList"] !== ""}
                      errorMessage={validationErrors["valueList"]}
                    />
                  )}
                  {/* These fields for specific File Field  */}

                  {fieldType === "file" && (
                    <div className="flex flex-col gap-2 text-sm w-full">
                      <Select
                        label="Files Accepted"
                        placeholder=" "
                        variant="faded"
                        selectionMode="multiple"
                        labelPlacement="outside"
                        className="my-8"
                        isRequired
                        selectedKeys={new Set(acceptFieldType)}
                        onSelectionChange={(event) => {
                          setAcceptFieldType(Array.from(event));
                        }}
                      >
                        {fileTypes?.map((item) => (
                          <SelectItem
                            key={item.key}
                            value={item.name}
                            className="py-2"
                          >
                            {item.name}
                          </SelectItem>
                        ))}
                      </Select>
                    </div>
                  )}

                  {/* These fields for specific Subheading Field  */}

                  {(fieldType === "subheading" || item?.Type === "subheading") && (
                    <>
                      <div className="flex flex-col gap-2 text-sm w-full">
                        <p>
                          Heading Level
                        </p>
                        <Dropdown>
                          <DropdownTrigger className="w-full">
                            <Button className="mb-8" variant="faded">
                              <div className="w-full flex justify-between">
                                <div className="flex justify-start w-full items-start">
                                  {headingLevel === "h2" ? "Large Heading (H2)" : 
                                   headingLevel === "h3" ? "Medium Heading (H3)" : 
                                   headingLevel === "h4" ? "Small Heading (H4)" : 
                                   "Select heading level"}
                                </div>
                                <div className="flex justify-end w-full items-end">
                                  <FaChevronDown />
                                </div>
                              </div>
                            </Button>
                          </DropdownTrigger>
                          <DropdownMenu
                            aria-label="Heading Level"
                            className="w-144"
                            selectionMode="single"
                            style={{ zIndex: 9999 }}
                            onSelectionChange={(event) => {
                              const selectedValue = Array.from(event)[0];
                              setHeadingLevel(selectedValue);
                            }}
                          >
                            <DropdownItem key="h2">Large Heading (H2)</DropdownItem>
                            <DropdownItem key="h3">Medium Heading (H3)</DropdownItem>
                            <DropdownItem key="h4">Small Heading (H4)</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>

                      <Textarea
                        type="text"
                        className="my-4"
                        variant="faded"
                        label="Description (Optional)"
                        labelPlacement="outside"
                        placeholder="Add an optional description for this section"
                        name="subheadingDescription"
                        value={subheadingDescription}
                        onChange={(event) => setSubheadingDescription(event.target.value)}
                      />
                    </>
                  )}

                  {/* These fields for specific Metric Selector Field  */}

                  {(fieldType === "metricSelector" || item?.Type === "metricSelector") && (
                    <>
                      <div className="flex flex-col gap-2 text-sm w-full">
                        <p>Metric Category Filter (Optional)</p>
                        <div className="text-xs text-gray-600 mb-4">
                          Choose which categories of metrics should be listed in this field. You can select multiple categories or leave empty to show all metrics.
                          {!isLoadingCategories && dynamicCategories.length > 0 && (
                            <span className="ml-2 text-emerald-600 font-medium">
                              ({dynamicCategories.length} categories available)
                            </span>
                          )}
                          {categoriesError && (
                            <span className="ml-2 text-orange-600 font-medium">
                              (Using fallback categories)
                            </span>
                          )}
                        </div>
                        
                        <Dropdown>
                          <DropdownTrigger className="w-full">
                            <Button className="mb-8" variant="faded" isLoading={isLoadingCategories}>
                              <div className="w-full flex justify-between">
                                <div className="flex justify-start w-full items-start">
                                  {isLoadingCategories ? "Loading categories..." : (
                                    metricCategoryFilter ? (
                                      Array.isArray(metricCategoryFilter) ? 
                                        `${metricCategoryFilter.length} categories selected` : 
                                        metricCategoryFilter
                                    ) : "Show all metric categories"
                                  )}
                                </div>
                                <div className="flex justify-end w-full items-end">
                                  <FaChevronDown />
                                </div>
                              </div>
                            </Button>
                          </DropdownTrigger>
                          <DropdownMenu
                            aria-label="Metric Category Filter"
                            className="w-144"
                            selectionMode="multiple"
                            style={{ zIndex: 9999 }}
                            selectedKeys={metricCategoryFilter ? new Set(Array.isArray(metricCategoryFilter) ? metricCategoryFilter : [metricCategoryFilter]) : new Set()}
                            onSelectionChange={(event) => {
                              const selectedValues = Array.from(event);
                              setMetricCategoryFilter(selectedValues.length > 0 ? selectedValues : "");
                            }}
                          >
                            {isLoadingCategories ? (
                              <DropdownItem key="loading" isReadOnly>
                                Loading categories...
                              </DropdownItem>
                            ) : dynamicCategories.length === 0 ? (
                              <DropdownItem key="no-categories" isReadOnly>
                                No categories available
                              </DropdownItem>
                            ) : (
                              dynamicCategories.map((category) => (
                                <DropdownItem key={category.name} value={category.name}>
                                  {category.name}
                                </DropdownItem>
                              ))
                            )}
                          </DropdownMenu>
                        </Dropdown>
                        
                        <div className="text-xs text-gray-500">
                          When users fill out forms with this field, they will only see metrics from the selected categories. 
                          If no categories are selected, all available metrics will be shown.
                        </div>
                      </div>
                    </>
                  )}

                  {/* These fields for specific Conditional Field  */}

                  {(fieldType === "conditional" || item?.Type === "conditional") && (
                    <>
                      <div className="flex flex-col gap-2 text-sm w-full">
                        <p>
                          Dependent Dropdown Field <span style={{ color: "red" }}>*</span>
                        </p>
                        <Input
                          type="text"
                          className="my-4"
                          variant="faded"
                          label="Dependent Field"
                          labelPlacement="outside"
                          placeholder="Field that this depends on"
                          value={dependentField}
                          onChange={(event) => setDependentField(event.target.value)}
                        />
                      </div>

                      <div className="flex flex-col gap-2 text-sm w-full">
                        <p>
                          Trigger Value <span style={{ color: "red" }}>*</span>
                        </p>
                        <Input
                          type="text"
                          className="my-4"
                          variant="faded"
                          label="Trigger Value"
                          labelPlacement="outside"
                          placeholder="Value that triggers this field to show"
                          value={triggerValue}
                          onChange={(event) => setTriggerValue(event.target.value)}
                        />
                      </div>

                      <div className="flex flex-col gap-2 text-sm w-full">
                        <p className="mb-2">Field Type to Show</p>
                        <Select
                          label="Field Type"
                          placeholder="Select field type"
                          variant="faded"
                          selectionMode="single"
                          labelPlacement="outside"
                          className="mb-8"
                          selectedKeys={dependentFieldType ? [dependentFieldType] : []}
                          onSelectionChange={(event) => {
                            setDependentFieldType(Array.from(event)[0]);
                          }}
                        >
                          <SelectItem key="text" value="text">Text Input</SelectItem>
                          <SelectItem key="textarea" value="textarea">Text Area</SelectItem>
                          <SelectItem key="integer" value="integer">Integer</SelectItem>
                          <SelectItem key="dropdown" value="dropdown">Dropdown</SelectItem>
                          <SelectItem key="file" value="file">File Upload</SelectItem>
                        </Select>
                      </div>

                      {dependentFieldType === "dropdown" && (
                        <Textarea
                          type="text"
                          className="my-4"
                          variant="faded"
                          label="Dropdown Options (comma-separated)"
                          labelPlacement="outside"
                          placeholder="Option 1, Option 2, Option 3"
                          value={dependentFieldConfig}
                          onChange={(event) => setDependentFieldConfig(event.target.value)}
                        />
                      )}
                    </>
                  )}

                  {item.Type === "link" && (
                    <Input
                      type="text"
                      className="mb-8"
                      isRequired
                      label="Link"
                      placeholder=" "
                      variant="faded"
                      labelPlacement="outside"
                      value={linkUrl || ""}
                      onChange={(event) => {
                        setLinkUrl(event.target.value);
                      }}
                      isInvalid={validationErrors["linkUrl"] !== ""}
                      errorMessage={validationErrors["linkUrl"]}
                    />
                  )}

                  {/* Framework Field */}
                  {category?.toLowerCase() !== "reference data" && (
                    <>
                      <div className="mt-12">
                        <Select
                          isRequired
                          label="Select Framework"
                          placeholder="Select any Framework"
                          variant="faded"
                          selectionMode="multiple"
                          labelPlacement="outside"
                          className="mb-8"
                          errorMessage={validationErrors["Framework"]}
                          isInvalid={validationErrors["Framework"] !== ""}
                          selectedKeys={frameWorkData}
                          onSelectionChange={(event) =>
                            setFrameWorkData(Array.from(event))
                          }
                        >
                          {frameWorkList?.map((item) => (
                            <SelectItem
                              key={item.id}
                              value={item.name}
                              className="py-2"
                            >
                              {item.name}
                            </SelectItem>
                          ))}
                        </Select>
                      </div>



                    </>
                  )}

                  {/* Group Assignment - for all fields except subheadings */}
                  {item.Type !== "subheading" && (
                    <div className="flex flex-col gap-2 text-sm w-full mb-4">
                      <p>Assign to Group (Optional)</p>
                      <Dropdown>
                        <DropdownTrigger className="w-full">
                          <Button variant="faded">
                            <div className="w-full flex justify-between">
                              <div className="flex justify-start w-full items-start">
                                {assignedGroup || "No group assignment"}
                              </div>
                              <div className="flex justify-end w-full items-end">
                                <FaChevronDown />
                              </div>
                            </div>
                          </Button>
                        </DropdownTrigger>
                        <DropdownMenu
                          aria-label="Group Assignment"
                          className="w-144"
                          selectionMode="single"
                          style={{ zIndex: 9999 }}
                          onSelectionChange={(event) => {
                            const selectedValue = Array.from(event)[0];
                            setAssignedGroup(selectedValue || "");
                          }}
                        >
                          <DropdownItem key="">No group assignment</DropdownItem>
                          {existingFields
                            .filter(field => field.Type === "subheading")
                            .map((field) => (
                              <DropdownItem key={field.Title}>
                                {field.Title}
                              </DropdownItem>
                            ))}
                        </DropdownMenu>
                      </Dropdown>
                      <p className="text-xs text-gray-500">
                        Choose which subheading group this field should appear under in the JSON output
                      </p>
                    </div>
                  )}

                  {(item.Type !== "link" && item.Type !== "subheading") && (
                    <div className="flex items-center">
                      <div className="flex-1">
                        <p className="mb-2">{"Make Required"}</p>
                        <Switch
                          isSelected={required}
                          color="primary"
                          className="mb-4"
                          label="Make Required"
                          labelPlacement="outside"
                          onChange={(event) => setRequired((pre) => !pre)}
                        >
                          {required ? "On" : "Off"}
                        </Switch>
                      </div>
                      {(item?.Type === "dropdown" ||
                        item?.Type === "relation") && (
                        <div className="flex-1">
                          <p className="mb-2">{"Multi-Select"}</p>
                          <Switch
                            isSelected={isMultiSelect}
                            color="primary"
                            className="mb-4"
                            // label="Make Required"
                            labelPlacement="outside"
                            onChange={(event) =>
                              setIsMultiSelect((pre) => !pre)
                            }
                          >
                            {isMultiSelect ? "Yes" : "No"}
                          </Switch>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button 
                  variant="ghost" 
                  className="text-slate-600 hover:text-slate-900 px-4" 
                  onPress={onClose}
                >
                  Cancel
                </Button>
                <Button 
                  color="primary" 
                  className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 font-medium"
                  onClick={() => submitHandler(onClose)}
                >
                  Update
                </Button>
              </ModalFooter>
            </div>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};
export default EditAddModal;
